import { observable, action, decorate, configure, runInAction } from 'mobx';
import axios from 'axios';
import {
  API_AUCTION_GET_TRANSCRIPTREPORT_ENDPOINT,
  DEV_API_URL,
} from '../shared/constants';
import { getStoredValue } from '../shared/utils/localStorage';
configure({ enforceActions: 'always' });

class AuctionTranscriptDataStore {
  constructor() {
    //console.log('haz called store')
    this.initializeAuctionTranscriptData();
  }
  initializeAuctionTranscriptData = () => {
    this.auctionTranscriptData = [];

    this.totalItems = 0;
    this.isLoading = true;
  };

  setProperty = (key, value) => {
    this[key] = value;
  };

  getProperty = (key) => {
    return this[key];
  };

  loadAuctionTranscriptData = async (
    auctionID,
    laneID,
    pageNumber,
    pageSize,
    searchText,
    messageType,
  ) => {
    if (!auctionID) {
      return;
    }
    this.isLoading = true;
    const sessionToken = sessionStorage.getItem("simulcastadmin_session");
    const params = JSON.stringify({
      sessionToken: sessionToken,
      auctionID: auctionID,
      laneID: laneID,
      searchParams: searchText,
      messageType: messageType,
      pageSize: pageSize,
      pageNumber: pageNumber,
    });

    // console.log('loadAuctionTranscriptData', {
    //   sessionToken: sessionToken,
    //   auctionID: auctionID,
    //   laneID: laneID,
    //   searchParams: searchText,
    //   messageType: messageType,
    //   pageSize: pageSize,
    //   pageNumber: pageNumber,
    // })
    // const transcriptDataURL = DEV_API_URL + API_AUCTION_GET_TRANSCRIPTREPORT_ENDPOINT
    const transcriptDataURL = API_AUCTION_GET_TRANSCRIPTREPORT_ENDPOINT;

    axios
      .post(transcriptDataURL, params, {
        headers: {
          'content-type': 'application/json',
        },
      })
      .then((res) => {
        runInAction(() => {
          this.auctionTranscriptData =
            res.data.pagedTranscriptHistory?.items || [];
          this.totalItems = res.data.pagedTranscriptHistory?.totalItems || 0;
          this.isLoading = false;
        });
      });
  };
}
decorate(AuctionTranscriptDataStore, {
  auctionTranscriptData: observable,
  initializeAuctionTranscriptData: action,
  setProperty: action,
  getProperty: action,
  setData: action,
  loadAuctionTranscriptData: action,
  isLoading: observable,
});

export default AuctionTranscriptDataStore;
